var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options"},[_c('div',{staticClass:"backdrop"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"loading"})])])}]

export { render, staticRenderFns }